export default __webpack_public_path__ + "static/media/visibility_24px.83b1b18b.svg";